import { AclConfig } from "./core/acl/models/acl-config.model";
import { UserRole } from "./core/models/user/user-role";

export const aclConfig: AclConfig = {
  enabledRoles: [UserRole.Plant, UserRole.Net],
  user: {
    modules: {},
    templates: {},
  },
  plant: {
    modules: {
      dashboard: {
        enabled: true,
        enabledChildren: {},
        features: {},
      },
      "user-details": {
        enabled: true,
        enabledChildren: {
          UserDetailsPageComponent: true,
          UserChangePasswordPageComponent: true,
          MfaConfigurationPageComponent: true,
        },
        features: {},
      },
      plants: {
        enabled: true,
        enabledChildren: {
          PlantsHomePageComponent: true,
          ClosureListPageComponent: true,
          TransactionsListPageComponent: true,
        },
        features: {},
      },
    },
    templates: {
      dashboard: {
        XSmall: { salesBar: 12, salesPie: 12, salesArea: 12 },
        Small: { salesBar: 12, salesPie: 12, salesArea: 12 },
        Medium: { salesBar: 12, salesPie: 4, salesArea: 8 },
        Large: { salesBar: 12, salesPie: 4, salesArea: 8 },
        XLarge: { salesBar: 12, salesPie: 4, salesArea: 8 },
      },
      salesTrend: {
        XSmall: {
          productsTrendsLines: 12,
          productsTotalTrendsBar: 12,
          productTotalsTrendsBarStacked: 12,
          productsTrendPie: 12,
        },
        Small: {
          productsTrendsLines: 12,
          productsTotalTrendsBar: 12,
          productTotalsTrendsBarStacked: 12,
          productsTrendPie: 12,
        },
        Medium: {
          productsTrendsLines: 12,
          productsTotalTrendsBar: 12,
          productTotalsTrendsBarStacked: 8,
          productsTrendPie: 4,
        },
        Large: {
          productsTrendsLines: 12,
          productsTotalTrendsBar: 12,
          productTotalsTrendsBarStacked: 8,
          productsTrendPie: 4,
        },
        XLarge: {
          productsTrendsLines: 12,
          productsTotalTrendsBar: 12,
          productTotalsTrendsBarStacked: 8,
          productsTrendPie: 4,
        },
      },
    },
  },
  net: {
    modules: {
      dashboard: {
        enabled: true,
        enabledChildren: {},
        features: {},
      },
      "user-details": {
        enabled: true,
        enabledChildren: {
          UserDetailsPageComponent: true,
          UserChangePasswordPageComponent: true,
          MfaConfigurationPageComponent: true,
        },
        features: {},
      },
      clients: {
        enabled: true,
        enabledChildren: {
          SalesTrendComponent: true,
          PlantsTotalsPageComponent: false,
          RevenueComponent: false,
          VehicleConsumptionPageComponent: true,
          // PrepayBalancesComponent: false,
          // PostpayBalancesComponent: true,
          WlfuelappSalesTrendPageComponent: true,
        },
        features: {},
      },
      bi: {
        enabled: true,
        enabledChildren: {
          BiPage: true,
        },
        features: {},
      },
      plants: {
        enabled: true,
        enabledChildren: {
          PlantsHomePageComponent: true,
          ClosureListPageComponent: true,
          TransactionsListPageComponent: true,
        },
        features: {},
      },
      netPro: {
        enabled: true,
        enabledChildren: {
          DailyTotalsPageComponent: true,
        },
        features: {},
      },
      ossPrezzi: {
        enabled: true,
        enabledChildren: {},
        features: {},
      },
      externalLinks: {
        enabled: true,
        enabledChildren: {},
        features: {},
      },
      assoPayments: { enabled: true, enabledChildren: {}, features: {} },
      assoStations: { enabled: true, enabledChildren: {}, features: {} },
    },
    templates: {
      dashboard: {
        XSmall: { salesBar: 12, salesArea: 12, salesPie: 12 },
        Small: { salesBar: 12, salesArea: 12, salesPie: 12 },
        Medium: { salesBar: 12, salesArea: 8, salesPie: 4 },
        Large: { salesBar: 12, salesArea: 8, salesPie: 4 },
        XLarge: { salesBar: 12, salesArea: 8, salesPie: 4 },
      },
      salesTrend: {
        XSmall: {
          productsTrendsLines: 12,
          productsTotalTrendsBar: 12,
          productTotalsTrendsBarStacked: 12,
          productsTrendPie: 12,
        },
        Small: {
          productsTrendsLines: 12,
          productsTotalTrendsBar: 12,
          productTotalsTrendsBarStacked: 12,
          productsTrendPie: 12,
        },
        Medium: {
          productsTrendsLines: 12,
          productsTotalTrendsBar: 12,
          productTotalsTrendsBarStacked: 8,
          productsTrendPie: 4,
        },
        Large: {
          productsTrendsLines: 12,
          productsTotalTrendsBar: 12,
          productTotalsTrendsBarStacked: 8,
          productsTrendPie: 4,
        },
        XLarge: {
          productsTrendsLines: 12,
          productsTotalTrendsBar: 12,
          productTotalsTrendsBarStacked: 8,
          productsTrendPie: 4,
        },
      },
    },
  },
};
